import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Is insurance a bad deal?' },
	{
		name: 'description',
		content: 'The best outcome is often having no claim at all',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/frequently-asked-questions/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				Frequently Asked Questions
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">
				Is Insurance a <em>Bad Deal</em> if I don't place a claim?
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<strong>
					I have paid a lot of money to insurance companies over the years. I
					have not received that much back because I haven't had any major
					claims. Is insurance a bad deal?
				</strong>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Insurance works by spreading the cost of claims for a group of people
				out over the group. If, on average, three out of every thousand
				households have a major claim such as a house fire each year, the
				insurance company needs to collect the insurance premiums from those
				thousand households in order to pay out for the three of them that have
				a fire. The other 997 households paid insurance premiums while receiving
				nothing in return except for the peace of mind of knowing they won't
				lose everything if they are one of the three unlucky ones.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In this situation, three households were saved from what could have been
				an even bigger tragedy. It's hard enough as it is to recover from a
				major event like this. Insurance helps people in a big way when they
				find themselves in this situation.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The numbers sometimes come out with the insurer profiting, and sometimes
				the insurer loses money. The fact that many insurers are available to
				compete in the marketplace is an advantage to consumers because the
				insurers are incentivized to set rates competitively to have an
				attractive offer. Of couse, in reality, there are many more types of
				claims that can occur besides a fire, and the policies are designed to
				offer consumers a variety of choices when it comes to what coverages are
				included and the amounts of protection.
			</p>
		</main>
	)
}
